"use client";
import { useEffect } from "react";
import { motion, stagger, useAnimate } from "framer-motion";
import { cn } from "@/lib/utils";

export const TextGenerateEffect = ({
  words,
  className,
  filter = true,
  duration = 0.5,
}: {
  words: string;
  className?: string;
  filter?: boolean;
  duration?: number;
}) => {
  const [scope, animate] = useAnimate();
  let letters = words.split("");
  
  useEffect(() => {
    animate(
      "span",
      {
        opacity: 1,
        filter: filter ? "blur(0px)" : "none",
      },
      {
        duration: duration ? duration : 1,
        delay: stagger(0.1),
      }
    );
  }, [scope.current, animate, duration, filter]);

  const renderLetters = () => {
    return (
      <motion.div ref={scope} className="inline-flex">
        {letters.map((letter, idx) => {
          return (
            <motion.span
              key={idx}
              className={cn("opacity-0 gradient-text")}
              style={{
                filter: filter ? "blur(8px)" : "none",
              }}
            >
              {letter}
            </motion.span>
          );
        })}
      </motion.div>
    );
  };

  return (
    <div className={cn("font-bold", className)}>
      <div className="text-6xl md:text-7xl">
        <div className="leading-snug tracking-wide">
          {renderLetters()}
        </div>
      </div>
    </div>
  );
};